var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":_vm.snackbarStatus ? 'success' : 'error',"top":"","right":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v("\n  "+_vm._s(_vm.snackbarStatus
      ? "Dane zostały zaktualizowane"
      : "Wystąpił błąd, spróbuj ponownie")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }